import { render } from "./UnifiedSalesReportTable.vue?vue&type=template&id=5d48117a&scoped=true"
import script from "./UnifiedSalesReportTable.vue?vue&type=script&lang=js"
export * from "./UnifiedSalesReportTable.vue?vue&type=script&lang=js"

import "./UnifiedSalesReportTable.vue?vue&type=style&index=0&id=5d48117a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\reportpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d48117a"]])

export default __exports__